/* ============================================================
   Papierschmiede: Poster und Rahmen als eine Warenkorb-Position
   ------------------------------------------------------------
   Gegenstueck zu snippets/ps-pd-warenkorbzeile.liquid. Menge und
   Loeschen an einer Posterzeile aus dem Poster-Designer gelten fuer
   Poster und Rahmen zugleich (je Poster ein Rahmen, gleiche Menge).

   Die Basis-Mechanik (cart.js: CartItems, CartRemoveButton) arbeitet
   mit /cart/change und nur einer Zeile. Deshalb fangen wir change und
   click an diesen Zeilen in der Capture-Phase ab, schicken beide Zeilen
   per /cart/update mit updates nach Zeilen-Key und rendern danach
   dieselben Sections, die CartItems selbst neu rendert. Alle anderen
   Zeilen laufen unveraendert ueber cart.js.
   Geht etwas schief, laden wir /cart neu.
   ============================================================ */
(() => {
  const DATEN_POSTER = 'data-ps-pd-poster';
  let zeitgeber = null;

  // Dieselbe Liste wie CartItems.getSectionsToRender() in cart.js; als
  // Rueckfall, falls cart.js (noch) nicht geladen ist.
  function sectionsVon(cartItems) {
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      return cartItems.getSectionsToRender();
    }
    const fuss = document.getElementById('main-cart-footer')?.dataset.id;
    return [
      { id: 'main-cart-items', section: document.getElementById('main-cart-items')?.dataset.id, selector: '.js-contents' },
      { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
      { id: 'main-cart-footer', section: fuss, selector: '.js-contents' }
    ];
  }

  function innerHTMLAus(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  async function setzeMenge(ausloeser, menge) {
    const posterKey = ausloeser.getAttribute(DATEN_POSTER);
    const rahmenKey = ausloeser.getAttribute('data-ps-pd-rahmen');
    if (!posterKey) return;

    const updates = { [posterKey]: menge };
    if (rahmenKey) updates[rahmenKey] = menge;

    const cartItems = ausloeser.closest('cart-items');
    const liste = sectionsVon(cartItems);
    const ids = [...new Set(liste.map((s) => s.section).filter(Boolean))];

    ausloeser.closest('li, tr')?.querySelector('.loading-overlay')?.classList.remove('hidden');
    document.getElementById('main-cart-items')?.classList.add('cart__items--disabled');

    try {
      const antwort = await fetch(`${window.routes.cart_update_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({ updates, sections: ids, sections_url: window.location.pathname })
      });
      if (!antwort.ok) throw new Error(`cart/update ${antwort.status}`);
      const stand = await antwort.json();
      if (!stand.sections) throw new Error('keine Sections in der Antwort');

      const leer = stand.item_count === 0;
      cartItems?.classList.toggle('is-empty', leer);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', leer);

      liste.forEach((s) => {
        const element = document.getElementById(s.id);
        const html = stand.sections[s.section];
        if (!element || !html) return;
        const ziel = element.querySelector(s.selector) || element;
        const inhalt = innerHTMLAus(html, s.selector);
        if (inhalt !== undefined) ziel.innerHTML = inhalt;
      });

      document.getElementById('main-cart-items')?.classList.remove('cart__items--disabled');
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: JSON.stringify(stand) } }));
    } catch (fehler) {
      console.error('ps-warenkorb:', fehler);
      window.location.href = window.routes?.cart_url || '/cart';
    }
  }

  // Menge: Eingabe oder Plus/Minus (QuantityInput feuert change am Feld)
  document.addEventListener('change', (event) => {
    const feld = event.target;
    if (!(feld instanceof HTMLInputElement) || !feld.hasAttribute(DATEN_POSTER)) return;
    event.stopImmediatePropagation();
    clearTimeout(zeitgeber);
    zeitgeber = setTimeout(() => {
      const menge = Math.max(0, parseInt(feld.value, 10) || 0);
      setzeMenge(feld, menge);
    }, 300);
  }, true);

  // Loeschen: Poster und Rahmen zusammen
  document.addEventListener('click', (event) => {
    const knopf = event.target instanceof Element && event.target.closest('[data-ps-pd-entfernen]');
    if (!knopf) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    setzeMenge(knopf, 0);
  }, true);
})();
